import React, { useState, useEffect } from 'react';
import { ExternalLink, BookOpen } from 'lucide-react';
import { relatedJournalsService } from '../services/api';

function RelatedJournals() {
  const [journals, setJournals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJournals = async () => {
      try {
        const response = await relatedJournalsService.getAll();
        if (response.data) {
          setJournals(response.data);
        }
      } catch (error) {
        console.error('Error fetching related journals:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchJournals();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">نشریات مرتبط</h1>
          <p className="text-xl text-blue-100">نشریات علمی مرتبط در حوزه معماری و مهندسی</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {journals.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {journals.map((journal, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition">
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <BookOpen className="w-6 h-6 text-blue-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900">{journal.name}</h3>
                    <p className="text-sm text-blue-700">{journal.field}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm mb-4">{journal.description}</p>
                <a
                  href={journal.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-blue-700 hover:text-blue-900 font-semibold text-sm"
                >
                  بازدید از سایت
                  <ExternalLink size={16} />
                </a>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default RelatedJournals;
